module.exports = __webpack_public_path__ + "media/images/icons/store_categories/icon-store-category-3-ce5e8238d7627c6504307bc362bdb9e8.svg";